const dialogStyle = {
  content: {
    margin: "25px",
    textAlign: "center"
  }
};

export default dialogStyle;
